export const TARGETINPUT_NONE = 0; // 選択なし
export const TARGETINPUT_SHOP = 1; // 店舗を選択(任意)
export const TARGETINPUT_SHOPMUST = 2; // 店舗を選択(必須)
export const TARGETINPUT_PLACE = 3; // 場所を選択(任意)
export const TARGETINPUT_PLACEMUST = 4; // 場所を選択(必須)
export const TARGETINPUT_SHOPPLACE = 5; // 店舗と場所を選択(任意)
export const TARGETINPUT_SHOPPLACEMUST = 6; // 店舗と場所を選択(必須)